<template>
  <module-page v-bind="pageParams">
    <screen-loading v-if="!loaded"></screen-loading>
    <iframe
      v-show="loaded"
      @load="load"
      scrolling="yes"
      ref="iframe"
      class="bank-financing__iframe"
      :src="url"
    />
  </module-page>
</template>

<script>
import ModulePage from '@/components/layout/Page';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import { APP, CONFIG } from '@/utils/constants';

export default {
  name: 'bank-financing',
  components: {
    ModulePage,
    ScreenLoading,
  },
  computed: {
    bankFinancingUrl() {
      return this.$store.getters[CONFIG.GET_JUNIX_BANK_FINANCING_BASE_URL];
    },
  },
  data() {
    return {
      url: null,
      loaded: false,
    };
  },
  created() {
    this.pageParams = this.$store.getters[APP.PAGES].bankFinancing;
    const contractValidTypes = ['PCV', 'Cessão'];
    const contract = this.selectedUnit.contracts.find((contract) =>
      contractValidTypes.some((t) => t === contract.type)
    );

    if (contract !== undefined) {
      const urlBase = this.bankFinancingUrl;
      const client = contract.proposers.find((p) => p.isMain === true);
      this.url = `${urlBase}/?numeroContrato=${contract.id}&clienteid=${client.id}`;
    }
  },
  beforeDestroy() {},
  methods: {
    load() {
      this.loaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
.bank-financing {
  &__iframe {
    width: 100%;
    height: 100%;
    min-width: 1021px;
    min-height: 1280px;
    border: none;
    margin-bottom: 10px;
    @include breakpoint(mobile) {
      min-width: initial;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/financial/BankFinancing.vue